<template>
  <div class="page-container">
    <div class="page-header">
      <h1>Specialists</h1>
    </div>
    <div class="stats-container">
      <div
        class="stat-card"
        v-for="(card, index) in stats"
        :key="index"
      >
        <div class="stat-circle">
          <img :src="card.image" alt="Stat icon" class="circle-image" />
        </div>
        <div class="stat-text">
          <div class="stat-label">{{ card.label }}</div>
          <div class="stat-number">{{ card.number }}</div>
          <div
            class="stat-growth"
            v-if="index === 0 || index === 1"
          >
            <span
              :class="{'arrow-up': card.growth >= 0, 'arrow-down': card.growth < 0}"
            >
              {{ card.growth >= 0 ? '▲' : '▼' }}
            </span>
            <span :class="card.growth >= 0 ? 'growth-up' : 'growth-down'">
              {{ Math.abs(card.growth) }}%
            </span>
            <span class="growth-label">this month</span>
          </div>
        </div>
        <div
          class="stat-line"
          v-if="index !== stats.length - 1"
        ></div>
      </div>
    </div>
    <div class="all-stats-container">
      <div class="row-wrapper">
        <div class="row-1">
          <h2>Specialists</h2>
          <div class="controls">
            <div class="search-bar">
              <button>
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" stroke="currentColor" fill="none">
                  <circle cx="11" cy="11" r="6" stroke-width="2"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65" stroke-width="2"></line>
                </svg>
              </button>
              <input
                v-model="searchQuery"
                @input="fetchSearchFilter"
                placeholder="Search"
            />
            </div>
            <div class="sort-by">
              <label>Sort by:</label>
                <select v-model="sortBy" @change="fetchSearchFilter">
                  <option value=""></option>
                  <option value="mostRecent">Most Recently Added</option>
                  <option value="leastRecent">Least Recently Added</option>
                  <option value="upcoming">Upcoming Scheduled Activites</option>
                </select>
                <ul>
                  <li v-for="student in students" :key="student.child_id">
                    {{ student.first_name }} {{ student.last_name }}
                    ({{ student.CompletionPct }}%)
                  </li>
                </ul>
            </div>
          </div>
        </div>
        <div>
          <OrganizationActualSpecialistTable :search="searchQuery"
    :sort-filter="sortBy"
    :click-sort="clickSort" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import image1 from '@/assets/SpecialistTotPatStu.jpg';
import image2 from '@/assets/SpecialistMembers.jpg';
import image3 from '@/assets/SpecialistActive.jpg';
import OrganizationActualSpecialistTable from "@/components/OrganizationActualSpecialistTable.vue";
import axios from "axios";

export default {
  components: {
    OrganizationActualSpecialistTable
  },
  data() {
    return {
      stats: [
        {
          label: 'Total Patients/Students',
          number: 100,
          image: image1,
          growth: 100
        },
        {
          label: 'Total Specialists',
          number: 18,
          image: image2,
          growth: 100
        },
        {
          label: 'Average Caseload',
          number: 1,
          image: image3
        }
      ],
      searchQuery: '',
      sortBy: 'first'
    };
  },
  mounted() {
    this.fetchSpecialistStats();
  },
  methods: {
    async fetchSpecialistStats() {
      try {
        const baseUrl = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";

        const authResp = await fetch(`${baseUrl}/api/auth/get-access-cookie-data`, {
          credentials: "include",
        });
        if (!authResp.ok) throw new Error("Failed to fetch auth cookie data");
        const authData = await authResp.json();
        const ID = authData.id;

        const response = await axios.get(`${baseUrl}/api/organization/user/${ID}/specialist-page-stats`);

        const data = response.data;

        this.stats[0].number = data.totalChildren;
        this.stats[0].growth = data.childPercentChange.toFixed(0);

        this.stats[1].number = data.totalSpecialists;
        this.stats[1].growth = data.specialistPercentChange.toFixed(0);

        this.stats[2].number = data.averageCaseload.toFixed(1);

      } catch (error) {
        console.error("Error fetching specialist stats:", error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.page-container {
  padding-top: 100px;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  h1 {
    font-size: 24px;
    font-weight: 600;
    color: black;
    margin: 0;
  }
  .start-activity-btn {
    background-color: #FFF5E3;
    color: #9D5f0E;
    border: none;
    border-radius: 6px;
    padding: 10px 20px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    &:hover {
      background-color: darken(#FFF5E3, 5%);
    }
  }
}
.stats-container {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 0; // we'll use fixed-width lines instead
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 20px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
.stat-card {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border-radius: 12px;
  background-color: white;
  text-align: center;
  min-width: 0;
  .stat-circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
  }
  .circle-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .stat-text {
    display: flex;
    flex-direction: column;
  }
  .stat-label {
    font-size: 16px;
    color: gray;
    margin-bottom: 4px;
  }
  .stat-number {
    font-size: 24px;
    font-weight: 700;
    color: black;
  }
}
.stat-growth {
  margin-top: 4px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.arrow-up {
  color: orange;
  font-size: 14px;
}
.arrow-down {
  color: red;
  font-size: 14px;
}
.growth-up {
  color: orange;
  font-weight: 600;
}
.growth-down {
  color: red;
  font-weight: 600;
}
.growth-label {
  color: gray;
}
.stat-divider {
  width: 1px;
  background-color: #e4e7ec;
  margin: 12px 12px;
}
.all-stats-container{
  display: flex;
  justify-content: space-between;
  gap: 20px;
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 20px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);;
}
.row-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px; 
  width: 100%
}
.row-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 0 20px;
  max-width: 1200px;
  margin-top: 0.5rem;
  padding-top: 0.5rem;

  h2 {
    font-size: 20px;
    font-weight: 600;
    color: black;
    margin: 0;
    flex: 1; 
  }
  .controls {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: flex-end;
    flex-shrink: 0; 
  }
  .search-bar {
  display: flex;
  align-items: center;
  max-width: 400px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9fafb;
  align-self: left;
  button {
    background: none;
    border: none;
    padding: 10px 16px;
    cursor: pointer;
    color: #475467; 
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
    .icon {
      width: 20px;
      height: 20px;
      stroke-width: 2;
    }
  }
  input {
    flex: 1;
    padding: 10px 16px;
    border: none;
    outline: none;
    font-size: 16px;
  }
}
.sort-by {
  display: flex;
  align-items: center;
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 4px 12px;
  gap: 6px;

  label {
    font-size: 14px;
    color: gray;
    margin: 0;
  }
  select {
    appearance: none; 
    border: none;
    background: #f9fafb;
    font-size: 14px;
    padding: 6px 24px 6px 0;
    cursor: pointer;
    outline: none;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' stroke='%23666' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 8l4 4 4-4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 4px center;
    background-size: 16px 16px;
  }
}
}
</style>